import React, { useEffect, useState } from 'react';
import Chat from './components/Chat';
import './App.css';

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  return (
    <div className="app-shell">
      <div className="bg-orb orb-one" aria-hidden="true" />
      <div className="bg-orb orb-two" aria-hidden="true" />

      <div className="App">
        <nav className="navbar">
          <div className="brand">
            <h1>Real-Time Chat</h1>
            <p>Instant messaging with typing indicators and emoji support</p>
          </div>

          <div className="nav-actions">
            <a
              className="explore-link"
              href="https://github.com/saksh3j"
              target="_blank"
              rel="noreferrer"
            >
              Explore More Projects
            </a>

            <button
              onClick={toggleTheme}
              className={`magic-toggle ${theme === 'dark' ? 'is-dark' : 'is-light'}`}
              aria-label="Toggle dark mode"
              aria-pressed={theme === 'dark'}
            >
              <span className="magic-track">
                <span className="magic-stars" />
                <span className="magic-cloud" />
                <span className="magic-thumb">
                  <span className="sun-icon">☀️</span>
                  <span className="moon-icon">🌙</span>
                </span>
              </span>
            </button>
          </div>
        </nav>

        <Chat />
      </div>
    </div>
  );
}

export default App;
